/**
 * Radix `DialogTitleWarning` calls `document.getElementById(titleId)`.
 * When the dialog portals into a ShadowRoot, the title node is not in
 * the light DOM, so Radix logs a false-positive accessibility error. We
 * extend `document.getElementById` to search known widget shadow hosts.
 */
export function installWidgetShadowDomIdLookup() {
  if (typeof document === 'undefined' || document.__ometricsShadowIdPatch) {
    return
  }
  document.__ometricsShadowIdPatch = true
  const original = document.getElementById.bind(document)
  document.getElementById = function patchedGetElementById(id) {
    if (id == null || id === '') return null
    const direct = original(id)
    if (direct) return direct
    try {
      const sel = `#${CSS.escape(String(id))}`
      const hosts = document.querySelectorAll('[id^="ometrics-ai-"]')
      for (const host of hosts) {
        const root = host.shadowRoot
        if (!root) continue
        const hit = root.querySelector(sel)
        if (hit) return hit
      }
    } catch {
      return null
    }
    return null
  }
}
